<template>
  <div>
    <div v-if="path" class="row no-gutters">
      <div class="col-3">
        <label
          v-tooltip="uniToolTipTranslation('S422', 'en-US')"
          class="label-unidato fluidSelectLabel"
        >
          {{ uniTranslation("TRNSL41") }}</label
        >
      </div>
      <div class="col-9">
        <el-select
          v-model="selectedFluid"
          class="fluidSelect"
          placeholder="Select a fluid"
          filterable
        >
          <el-option
            v-for="item in fluidList"
            v-if="item.fast !== 0"
            :key="item.webId"
            :label="item.description"
            :value="item.webId"
          >
            <!-- 
              v-tooltip="uniToolTipTranslation(item.description, 'en-US')"-->

            <span style="float: left"><i class="fa fa-tint"></i> {{ item.description }}</span>
          </el-option>

          <el-option-group v-for="group in fluidTypologies" :key="group.id" :label="group.typology">
            <el-option
              v-for="item in fluidList"
              v-if="item.tipologia == group.id && item.fast === 0"
              :key="item.webId"
              :label="item.description"
              :value="item.webId"
            >
              <!-- 
              v-tooltip="uniToolTipTranslation(item.description, 'en-US')"-->

              <span style="float: left">{{ item.description }}</span>
              <span class="numberCircle">{{ group.shortDescr }} </span>
            </el-option>
          </el-option-group>
        </el-select>
      </div>
    </div>
    <div>
      <UnidataEditor v-show="requiresConcentration" :parent-path="path" :name="'.concetration'">
      </UnidataEditor>
      <UnidataEditor v-show="requiresPressure" :parent-path="path" :name="'.fluidPressure'">
      </UnidataEditor>
    </div>
  </div>
</template>

<script>
import { Select, Option, OptionGroup } from "element-ui";
import UnidataEditor from "../unidata/UnidataEditor";
import jsonHelper from "../../shared/jsonHelper";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    "el-select": Select,
    "el-option-group": OptionGroup,
    "el-option": Option,
    UnidataEditor
  },
  props: {
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedFluid: "",
      fluidTypologies: [],
      fluidList: [],
      requiresConcentration: false,
      requiresPressure: false
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"]),
    ...mapGetters("_fluidModule", ["fluidsList", "refrigerantsList"])
  },
  watch: {
    selectedFluid: function(nv /*, ov*/) {
      if (nv != null && nv != undefined) {
        
        var that = this;
        var tipologia = parseInt(nv / 10000);
        var idf = parseInt(nv % 10000);

        //alert(this.path + ".fluid.webId becomes " + tipologia + " " + idf);

        var tmpFluid = jsonHelper.getProperty(that.projects, that.path + ".fluid");
        tmpFluid.tipologia = tipologia;
        tmpFluid.id = idf;


        this.changeProperty({
          path: this.path + ".fluid",
          value: tmpFluid
        });
        /*
        this.changeProperty({
          path: this.path + ".fluid.tipologia",
          value: tipologia
        });

        this.changeProperty({
          path: this.path + ".fluid.id",
          value: idf
        });
        */

        var fld = that.fluidList.find(function(obj) {
          return obj.id === idf && obj.tipologia === tipologia;
        });

        //console.log("New fluid: " + idf + " typ. " + tipologia);

        that.requiresConcentration = tipologia == 12;
        that.requiresPressure = fld.requiredPressure !== 0;

        /*this.$store.dispatch("changeProjectProperty", {
            path: this.path + ".fluid.id",
            value: idf
          });*/
      }
    }
  },
  mounted: function() {
    var that = this;
    that.$nextTick(function() {
      that.requiresConcentration = false;
      that.requiresPressure = false;

      //fluidService.getFluids().then(function(data) {
      if (that.fluidsList.length > 0) {
        that.fluidsList.forEach(element => {
          that.fluidList.push({
            filename: element.filename,
            description: element.filename
              .split(".")
              .slice(0, -1)
              .join("."),
            id: element.id,
            tipologia: element.tipologia,
            orderId: element.orderId,
            requiredPressure: element.requiredPressure,
            tipoStruttura: element.tipoStruttura,
            fast: element.fast,
            webId: element.tipologia * 10000 + element.id
          });
        });

        var idWeb =
          jsonHelper.getProperty(that.projects, that.path + ".fluid.tipologia") * 10000 +
          jsonHelper.getProperty(that.projects, that.path + ".fluid.id");


        for (var i = 0; i < that.fluidList.length; i++) {
          if (idWeb == that.fluidList[i].webId) {
            that.selectedFluid = idWeb;
            break;
          } else {
            that.selectedFluid = that.fluidList[0].webId;
          }
        }

        //});


        that.fluidTypologies.push({
          id: 11,
          typology: "Pure liquids",
          shortDescr: "PL"
        });

        that.fluidTypologies.push({
          id: 12,
          typology: "Mixed liquids",
          shortDescr: "ML"
        });

        that.fluidTypologies.push({
          id: 13,
          typology: "Pure gases",
          shortDescr: "PG"
        });

        that.fluidTypologies.push({
          id: 14,
          typology: "Mixed gases",
          shortDescr: "MG"
        });
      }
    });
  },
  methods: {
    ...mapActions("_prjModule", ["changeProperty"])
  }
};
</script>

<style lang="scss">
.fluidSelectRow {
  margin-right: 0px;
  margin-left: 0px;
  .col-3 {
    padding-right: 0px;
    padding-left: 0px;
  }
  .col-9 {
    padding-right: 0px;
    padding-left: 0px;
  }
}
.fluidSelectLabel {
  margin-top: 5px;
  //padding-left: 5px;
}
.fluidSelect {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 5px;
  padding: 0 5px;
  .el-input {
    .el-input__inner {
      height: 30px;
    }
  }
}
.numberCircle {
  float: right;
  color: #8492a6;
  font-size: 10px;

  /*border-style: solid; 
    border-width: 1px;
    border-radius: 50%;
    border: 2px solid #666;
    width: 24;
    height: 32px;*/
  text-align: center;
  vertical-align: middle;

  /*border-radius: 50%;
    / *behavior: url(PIE.htc); /* remove if you don't care about IE8 * /

    width: 32px;
    height: 32px;
    padding-top: 0px;
    padding-right: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
    
    background: #fff;
    border: 2px solid #666;
    color: #666;
    text-align: center;
    vertical-align: middle;
    
    / *font: 32px Arial, sans-serif;*/
}
</style>
